import { Breadcrumb } from 'antd';
import { isEmpty, isNull, isUndefined, startCase } from 'lodash';
import getConfig from 'next/config';
import React from 'react';
import searchResource from '../../../locales/th/search.json';
import { BreadcrumbWrapper } from './SrpBreadcrumb.style';
import { ProjectItem } from '../../../queries/fragments/project';

const { publicRuntimeConfig } = getConfig();
const baseUrl = publicRuntimeConfig.baseUrl;
const TYPE_PROJECT_EN = 'project';
const TYPE_PROJECT_THAI = 'โครงการ';

interface SrpBreadcrumbProps {
  type?: string;
  slug?: string;
  searchTitle?: string;
  projectItems?: ProjectItem[];
}
const isProjectType = (type: string) =>
  type === TYPE_PROJECT_EN || type === TYPE_PROJECT_THAI;

const SrpBreadcrumb: React.FC<SrpBreadcrumbProps> = ({
  type,
  slug,
  searchTitle,
  projectItems,
}) => {
  const getBreadcrumb = () => {
    const allProjectsText = searchResource.searchFilter.allProjects;
    const objBreadcrumb = [{ name: 'Home', link: baseUrl }];

    if (isUndefined(type) && isUndefined(slug) && isEmpty(searchTitle)) {
      objBreadcrumb.push({ name: allProjectsText, link: null });
    } else if (
      !isUndefined(type) &&
      !isUndefined(slug) &&
      !isEmpty(searchTitle)
    ) {
      objBreadcrumb.push({
        name: isProjectType(type) ? startCase(slug) : slug,
        link: null,
      });
    } else if (
      isUndefined(type) &&
      isUndefined(slug) &&
      !isEmpty(searchTitle)
    ) {
      objBreadcrumb.push({ name: allProjectsText, link: `${baseUrl}list/` });
      if (!isEmpty(projectItems)) {
        objBreadcrumb.push({ name: searchTitle, link: null });
      }
    }
    return objBreadcrumb;
  };
  const listBreadcrumb = getBreadcrumb();

  return (
    <BreadcrumbWrapper data-test={'srp-breadcrumb'}>
      <Breadcrumb className="breadcrumb">
        {listBreadcrumb.map(function (v, k) {
          if (!isNull(v.link)) {
            return (
              <Breadcrumb.Item key={v.name} data-test={'breadcrumb-item-' + k}>
                <a href={v.link}>{v.name}</a>
              </Breadcrumb.Item>
            );
          } else {
            return (
              <Breadcrumb.Item key={v.name} data-test={'breadcrumb-item-' + k}>
                {v.name}
              </Breadcrumb.Item>
            );
          }
        })}
      </Breadcrumb>
    </BreadcrumbWrapper>
  );
};

export default SrpBreadcrumb;
